import { ref, onMounted, onUnmounted, computed } from 'vue';

export function useSeamlessScroll(itemHeight = 45, minCount = 5) {
    const scrollTop = ref(0);
    let animationId = null;

    const step = () => {
        scrollTop.value = (scrollTop.value + 0.5) % (minCount * itemHeight);
        animationId = requestAnimationFrame(step);
    };

    onMounted(() => {
        if (minCount > 5) {
            animationId = requestAnimationFrame(step);
        }
    });

    onUnmounted(() => {
        cancelAnimationFrame(animationId);
    });

    return {
        scrollStyle: computed(() => ({
            transform: `translateY(-${scrollTop.value}px)`,
            willChange: 'transform',
        })),
    };
}
